<template>
  <div :class="$style['basket-css']">
    <div v-if="isAllowed != null && isAllowed" :class="$style['header-basket']">
      <h2 v-if="stage == 0">
        جهت انتخاب فروشگاه و یا تغییر فروشگاه با لمس نام فروشگاه میتوانید فروشگاه مورد نظر را انتخاب کنید.
        برای
        تکمیل مراحل فرآیند خرید، از شماره راهنما استفاده کنید.
      </h2>
      <h2 v-if="stage == 1">
        لطفا نوع سفارش خود را با دقت انتخاب کنید، سپس "ادامه ثبت سفارش" را لمس کنید. تا قبل از ثبت سفارش
        امکان ویرایش وجود دارد.
      </h2>
      <h2 v-if="stage == 2">
        لطفا جهت ثبت سفارش، آدرس خود را انتخاب کرده و یا در صورتی که مایل به ثبت آدرس جدید هستید، "افزودن آدرس"
        را لمس کنید.
      </h2>
      <h2 v-if="stage == 3">
        فاکتور نهایی سفارش شما ایجاد گردید، در صورت تایید جهت پرداخت از درگاه بانکی و یا کیف پول درون برنامه
        ای، "تکمیل سفارش" را لمس کنید.
      </h2>
      <div style="margin-top: 10px; display: flex; align-items: center" v-if="stage != 3">
        <div style="background-color: #7dc353; border-radius: 50%;
                color: white; padding-top: 3px; width: 30px; height: 30px;display: flex;justify-content: center;">
          <span v-if="stage == 0">1</span>
          <span v-if="stage == 1">3</span>
          <span v-if="stage == 2">5</span>
        </div>
        <div style="display: flex; margin-right: 10px; justify-content: space-between">
          <v-icon v-if="stage == 0" style="color: #7dc353; margin-left: 5px">store</v-icon>
          <span v-if="stage == 0 && shop != null" style="font-size: 15px"
                class="font-weight-bold">{{ shop.shop_name }}</span>

          <v-icon v-if="stage == 1" style="color: #7dc353; margin-left: 5px">local_drink</v-icon>
          <span v-if="stage == 1 && deliveryType == 0"
                style="font-size: 15px" class="font-weight-bold">سفارش حضوری (تحویل درب فروشگاه)</span>
          <span v-if="stage == 1 && deliveryType == 1"
                style="font-size: 15px" class="font-weight-bold">سفارش دلیوری (تحویل درب منزل)</span>

          <v-icon v-if="stage == 2" style="margin-left: 5px">not_listed_location</v-icon>
          <span v-if="stage == 2" style="font-size: 15px"
                class="font-weight-bold">آدرس خود را مشخص کنید</span>
        </div>
      </div>
      <div v-if="stage > 0" role="button" v-ripple @click="checkBack"
           style="font-size: 10px; margin-right: auto; float: left; margin-top: 5px">مرحله قبل
        <v-icon style="margin: 0">chevron_left</v-icon>
      </div>
    </div>

    <div v-if="isAllowed != null&& isAllowed" :class="$style['itemsBasket']">
      <div :class="$style['contentBasket']" v-if="stage == 0">
        <div :class="$style['productBasket']"
             v-for="(item, index) in basketData.basket" :key="'product-' + index">
          <div class="d-flex flex-column" style="width: 100%">
            <div :class="$style['imageBasket-top']">
              <div :class="$style['imageBasket']">
                <img :src="item.product_icon" alt=""/>
              </div>
              <div style="display: flex; flex-direction: column; flex: 1;">
                <span class="multi-line" style="font-size: 13px">{{ item.product_title }}</span>
                <span class="font-weight-bold"
                      style="font-size: 15px; color: #7dc353">{{ oracle.format(item.product_sell_price) }} تومان</span>
              </div>
              <div :class="$style['addproductBasket']">
                <ul>
                  <li role="button" v-ripple @click="plusItem(item)">
                    <v-icon>add</v-icon>
                  </li>
                  <li style="color: #7dc353; padding: 0 10px 0 10px">
                    {{
                      item.product_count > item.product_quantity ? item.product_quantity :
                          item.product_count
                    }}
                  </li>
                  <li role="button" v-ripple @click="minusItem(item)">
                    <v-icon>remove</v-icon>
                  </li>
                </ul>
              </div>
            </div>
            <div class="d-flex flex-column mb-3 mt-1"
                 v-if="item.product_options != null && item.product_options.length > 0">
              <div role="button" @click="toggleItem(item)" class="flex-row d-flex align-center"
                   style="width: 100%; background-color: #7dc353;">
                <span class="mr-2 ml-2 white--text f8">انتخاب گزینه های
                  <span class="white--text f9" style="font-weight: bold">{{ item.product_title }}</span>
                  </span>
                <i v-if="productExpanded[item.product_id] != null && productExpanded[item.product_id]"
                   class="mdi  mdi-chevron-down-box-outline white--text f15 mr-auto ml-2"></i>
                <i v-else class="mdi mdi-chevron-left-box-outline white--text f15 mr-auto ml-2"></i>
              </div>
              <div v-if="productExpanded[item.product_id] != null && productExpanded[item.product_id]"
                   class="d-flex flex-column">
                <div class="d-flex flex-column" v-for="index in item.product_count" :key="index">
                  <span v-if="item.product_count > 1"
                        class="text--black f7 pt-1 pr-2 pl-2 pb-1" style="background-color: #807ec352">
                    {{ item.product_title }} {{ counterTitle(index) }}
                  </span>
                  <div class="flex-row d-flex align-center" role="button" @click="setOption(item, index, option)"
                       style="width: 100%; border-bottom: 1px solid lightgrey"
                       v-for="(option, optionsIndex) in item.product_options" :key="optionsIndex">
                    <i v-if="productMap[item.product_id][index + '-'+ option.key]"
                       class="mdi mdi-check-circle f12 mr-1 ml-1" style="color: #7dc353"></i>
                    <i v-else class="mdi mdi-circle-outline f12 mr-1 ml-1" style="color: #7dc353"></i>
                    <span class="f9 ml-auto" style="color: #7dc353">{{ option.key }}</span>
                    <span v-if="option.value != null && option.value.length > 0"
                          class="f10 font-weight-bold" style="color: #7dc353">{{ oracle.format(option.value) }}</span>
                    <span v-if="option.value != null && option.value.length > 0"
                          class="f7 font-weight-bold mr-1 ml-2" style="color: #7dc353">تومان</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else style="height: 1px; background-color: #806c757d; width: 100%"></div>
          </div>
        </div>
        <div role="button" v-ripple :style="item.id == selectedCoupon ? 'border: 3px solid #2ab0f7;' : ''"
             style="background-color: #7dc353; margin: 20px; border-radius: 20px; width: 100%; padding: 10px"
             class="d-flex mr-auto ml-auto flex-column" v-for="(item, index) in coupons" :key="index"
             @click="selectedCoupon = item.id">
                    <span class="font-weight-bold ml-auto" style="color: white; font-size: 15px">
                        {{ (item.id == selectedCoupon ? "✓ " : "") + item.title }}
                    </span>
          <span class="ml-auto mt-2 mb-2" style="color: white; font-size: 11px">{{ item.expireText }}</span>
          <span v-if="item.id == selectedCoupon" class="mr-auto"
                style="background-color: #2ab0f7; width: fit-content;color: white ; border-radius: 25px; padding: 2px 10px; font-size: 12px;">✓ اعمال شد</span>
          <span v-else class="mr-auto"
                style="background-color: white; width: fit-content; color: #7dc353; border-radius: 25px; padding: 2px 10px; font-size: 12px;">● برای اعمال لمس کنید</span>
        </div>
        <div class="d-flex flex-row  mt-5 mb-3">
          <span class="ml-auto  mt-5 mb-3" style="font-size: 12px; color: #9a9696;" v-if="suggests.length > 0">سبد خرید خود را با این پیشنهادات تکمیل کنید!</span>
        </div>
        <div class="d-flex flex-row" style="align-items: center;"
             v-for="(item, index) in suggests" :key="index">
          <div :class="$style['imageBasket']">
          </div>
          <div style="display: flex; flex-direction: column; flex: 1;">
            <span class="multi-line" style="font-size: 13px">{{ item.product_title }}</span>
          </div>
          <span class="mr-auto" role="button" v-ripple @click="plusItem(item)"
                style="background-color: #2ab0f7; width: fit-content; color: white; border-radius: 25px; padding: 2px 10px; font-size: 12px;">+ افزودن</span>
        </div>
        <div style="height: 100px"></div>
      </div>

      <div :class="$style['contentBasket']" v-if="stage == 1">
        <div style="align-items: center" role="button" v-ripple @click="deliveryType = item.deliveryTypeId"
             class="d-flex flex-row" v-for="(item, index) in store"
             :key="index">
          <v-icon color="#7dc353" style="width: 20px; height: 20px;"
                  :style="'opacity: ' + (item.deliveryTypeId == deliveryType ? 1 : 0)" class="ml-3 mr-2">
            check_circle
          </v-icon>
          <div class="d-flex flex-column"
               style="text-align: right; margin-top: 5px; margin-bottom: 5px"
               v-if="item.deliveryTypeId == 0 || (item.deliveryTypeId == 1 && shop.shop_delivery)">
            <h4>
              {{ item.deliveryTypeTitle }}
            </h4>
            <p style="margin-bottom: 0; font-size: 13px; color: #9a9696; text-align: justify;margin-left: 25px">
              {{ item.deliveryTypeDetail }}
            </p>
          </div>
        </div>
      </div>
      <div :class="$style['contentBasket']" v-if="stage == 2">
        <div v-if="userProfile != null" :class="$style['address-box']">
          <v-radio-group v-if="userProfile.user_addresses != null" v-model="selectedAddress" mandatory>
            <v-radio
                :class="$style['labelStyle']"
                v-for="(item, index) in userProfile.user_addresses"
                :key="index"
                :value="item"
                style="border-bottom: 1px solid #6d6d6d3d; display: flex; align-items: center">
              <template :class="$style['labelStyle']" v-slot:label>
                <div style="text-align: right; margin-top: 5px; margin-bottom: 5px">
                  <h4>
                    {{ item.address_title }}
                  </h4>
                  <p style="margin-bottom: 0; font-size: 13px; color: #9a9696; text-align: justify;margin-left: 25px">
                    {{ item.address_description }}
                  </p>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <div :class="$style['add-address']" role="button" v-ripple @click="$router.push('/address')"
               style="display: flex; margin: 0 10px 0 10px; align-items: center">
            <v-icon style="font-size: 32px; color: #7dc353; margin-left: 5px">add_circle</v-icon>
            افزودن آدرس
          </div>
          <div style="height: 100px"></div>
        </div>
      </div>

      <div :class="$style['contentBasket']" v-if="stage == 3">
        <div v-if="factorReceipt != null"
             style="display: flex;flex-direction: column; margin: 0 10px 0 10px; line-height: 2">
          <h4 style="border-bottom: 1px solid #b8b7b7;">جزئیات خرید</h4>
          <div :class="$style['css-final']"
               v-for="(item, index) in payment_detail"
               :key="index">
            <span style="font-size: 14px !important;" class="multi-line">{{
                item.product_title
              }}  ({{ item.product_quantity }} عدد)</span>
            <span style="color: #7dc353; font-size: 15px !important;">{{
                oracle.format(item.product_quantity * item.product_sell_price)
              }} تومان</span>
          </div>
          <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
               v-if="factorReceipt.delivery != null && factorReceipt.delivery > 0">
                        <span style="font-size: 14px">
                            هزینه ارسال با پیک
                        </span>
            <span style="color: #7dc353;  font-size: 15px;">
                            {{ oracle.format(factorReceipt.delivery) }} تومان
                        </span>
          </div>
          <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
               v-if="factorReceipt.options != null && factorReceipt.options > 0">
                        <span style="font-size: 14px">
                            هزینه ملزومات سفارش
                        </span>
            <span style="color: #7dc353;  font-size: 15px;">
                            {{ oracle.format(factorReceipt.options) }} تومان
                        </span>
          </div>
          <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
               v-if="factorReceipt.packaging != null && factorReceipt.packaging > 0">
                        <span style="font-size: 14px">
                            هزینه بسته بندی
                        </span>
            <span style="color: #7dc353;  font-size: 15px;">
                            {{ oracle.format(factorReceipt.packaging) }} تومان
                        </span>
          </div>
          <div class="d-flex flex-row justify-space-between" style="border-bottom: 1px solid #b8b7b7;"
               v-if="factorReceipt.vat != null && factorReceipt.vat > 0">
                        <span style="font-size: 14px">
                           مالیات ارزش افزوده
                        </span>
            <span style="color: #7dc353;  font-size: 15px;">
                            {{ oracle.format(factorReceipt.vat) }} تومان
                        </span>
          </div>
          <div class="d-flex flex-row align-center pr-2 pl-2 mt-2 mb-1 rounded"
               style="background: #7dc353; color: white !important;"
               v-if="factorReceipt.credit != null && factorReceipt.credit > 0">
            <v-switch style="direction: ltr !important;" color="white" v-model="credit_switch"></v-switch>
            <span class="ml-auto mr-2" style="font-size: 14px; color: white !important;">
                            استفاده از اعتبار کیف پول
                        </span>
            <span style="color: white !important;  font-size: 15px;">
                            {{ oracle.format(factorReceipt.credit) }} تومان
                        </span>
          </div>
          <div class="d-flex flex-row" style="border-bottom: 1px solid #b8b7b7;"
               v-if="factorReceipt.coupon != null">
                        <span class="ml-auto" style="color: #7dc353;  font-size: 15px;">
                            {{ "✓" + " " + factorReceipt.coupon }}
                        </span>
          </div>
          <div class="d-flex flex-row pt-2 pb-2 justify-space-between font-weight-bold"
               style="border-bottom: 1px solid #b8b7b7;"
               v-if="factorReceipt.order != null && factorReceipt.order > 0">
                        <span style="font-size: 14px">
                            مبلغ نهایی سفارش
                            <br>
                            <span class="font-weight-medium">
                              {{
                                (
                                    factorReceipt.discount_percent != null && factorReceipt.discount_percent > 0 ? ("با اعمال " + factorReceipt.discount_percent + " درصد تخفیف ")
                                        : (factorReceipt.discount_amount != null && factorReceipt.discount_amount > 0 ? (oracle.format(factorReceipt.discount_amount)) + ' تومان تخفیف محصولات' : '')
                                )
                              }}
                            </span>
                        </span>
            <span style="color: #7dc353; font-size: 15px;">
                            {{ oracle.format(factorReceipt.order) }} تومان
                        </span>
          </div>

          <div style="display: flex;flex-direction: column; flex-wrap: wrap; font-size: 15px; margin-top: 20px"
               v-if="basketData.optionsText != null && basketData.optionsText.length > 0">
            <span style="color: #7dc353; font-weight: bold; font-size: 17px;">ملزومات سفارش</span>
            <p style="white-space: pre-wrap">{{ basketData.optionsText }}</p>
          </div>
          <div style="display: flex;flex-direction: column; flex-wrap: wrap; font-size: 15px; margin-top: 20px"
               v-if="deliveryType == 0">
            <span style="color: #7dc353; font-weight: bold; font-size: 17px;">تحویل درب فروشگاه</span>
            <p class="font-weight-bold">{{ basketData.shop_address }}</p>
          </div>
          <div style="display: flex;flex-direction: column; flex-wrap: wrap; font-size: 15px; margin-top: 20px"
               v-if="deliveryType == 1">
            <span style="color: #7dc353; font-weight: bold; font-size: 17px;">تحویل درب منزل</span>
            <p v-if="selectedAddress != null" class="font-weight-bold">{{
                selectedAddress.address_description
              }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isAllowed != null&& isAllowed" :class="$style['footerBasket']">
      <div v-if="stage != 3" :class="$style['amountBasket']">
        <span>مبلغ قابل پرداخت<span class="mr-1" style="font-size: 10px !important; color: black !important;">(قبل از تخفیف)</span></span>
        <span v-if="stage == 3 && factorReceipt != null">{{ oracle.format(factorReceipt.total) }} تومان</span>
        <span v-else-if="finalPrice != null">{{ oracle.format(finalPrice) }} تومان</span>
      </div>
      <div :class="$style['btnaddAddress']">
        <div :class="$style['my-2']">
          <v-btn x-large color="#7ec352" dark role="button" v-ripple @click="checkNext">
            <div style="background-color: white; border-radius: 50%;
                color: white; width: 25px; align-items: center;
                height: 25px;display: flex;justify-content: center; margin-left: 10px">
              <span style="color: #7ec352; "> {{ stage == 0 ? 2 : stage == 1 ? 4 : 5 }} </span>
            </div>
            {{ stage != 3 ? 'مرحله بعد' : 'تکمیل سفارش' }}
            <v-icon style="z-index: 10; color: white">chevron_left</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div :class="$style['basketAllowBox']" v-if="isAllowed != null && !isAllowed" class="d-flex flex-column">
      <img src="../assets/image/cluna/app_logo_white_wide.jpg" alt="">
      <span>{{ purchaseAllowMessage }}</span>
      <v-btn color="white" rounded role="button" v-ripple @click="$router.push('/main')">بازگشت به خانه</v-btn>
    </div>

    <v-progress-circular v-if="isAllowed == null" indeterminate color="#7ec352"
                         style="margin: auto"></v-progress-circular>
  </div>
</template>
<script>
import oracle from "@/utils/oracle";

export default {
  name: "Basket",
  components: {},
  data: () => ({
    purchaseAllowMessage: null,
    isAllowed: null,
    productMap: {},
    productExpanded: {},
    factorReceipt: null,
    oracle: oracle,
    stage: -1,
    store: [
      {
        deliveryTypeId: 1,
        deliveryTypeTitle: "سفارش دلیوری (تحویل درب منزل)",
        deliveryTypeDetail:
            "فروشگاه انتخاب شده، دارای قابلیت ارسال با پیک جهت تحویل درب منزل میباشد. توجه فرمائید محدوده ارسال تا شعاع 2.5 کیلومتری میباشد. هزینه پیک نیز به صورت جداگانه محاسبه خواهد شد.",
      },
      {
        deliveryTypeId: 0,
        deliveryTypeTitle: "سفارش حضوری (تحویل در فروشگاه)",
        deliveryTypeDetail:
            "در صورت انتخاب این گزینه، میبایست جهت تحویل گرفتن سفارش به صورت حضوری به فروشگاه مراجعه کنید و سفارش خود را با اعلام کد سفارش تحویل بگیرید",
      },
    ],
    selectedAddress: null,
    deliveryType: 0,
    shop: null,
    selectedCoupon: null,
    basketData: [],
    coupons: [],
    suggests: [],
    credit_switch: false,
    payment_detail: [],
    userProfile: null,
    finalPrice: null,
  }),
  methods: {
    counterTitle(index) {
      switch (index - 1) {
        case 0:
          return "اول"
        case 1:
          return "دوم"
        case 2:
          return "سوم"
        case 3:
          return "چهارم"
        case 4:
          return "پنجم"
        case 5:
          return "ششم"
        case 6:
          return "هفتم"
        case 7:
          return "هشتم"
        case 8:
          return "نهم"
        case 9:
          return "دهم"
      }
    },
    setOption(item, index, option) {
      let data = this.productMap[item.product_id][index + '-' + option.key]
      this.productMap[item.product_id][index + '-' + option.key] = data ? !data : true
      this.checkOrder()
    },
    toggleItem(item) {
      this.productExpanded[item.product_id] = !(this.productExpanded[item.product_id] != null && this.productExpanded[item.product_id]);
      this.$forceUpdate();
    },
    generateProductMap() {
      let productMap = []
      for (let key in this.productMap) {
        let value = this.productMap[key]
        if (value != null) {
          let innerArray = []
          for (let key in value) {
            if (value[key] != null && value[key] == true) {
              innerArray.push(key)
            }
          }
          productMap.push({
            product_id: key,
            options: innerArray
          })
        }
      }
      return productMap
    },
    checkNext() {
      if (!oracle.getToken()) {
        oracle.showMessage('برای ثبت سفارش میبایست وارد حساب کاربری خود شوید.', 'ثبت نام / ورود', () => {
          this.$router.push('/profile?login=true')
        })
        return
      }
      this.payment_detail = [];
      for (let i = 0; i < this.basketData.basket.length; i++) {
        let count = this.basketData.basket[i].product_count > this.basketData.basket[i].product_quantity
            ? this.basketData.basket[i].product_quantity : this.basketData.basket[i].product_count
        if (count > 0) {
          this.payment_detail.push({
            product_id: this.basketData.basket[i].product_id,
            product_title: this.basketData.basket[i].product_title,
            product_sell_price: this.basketData.basket[i].product_sell_price,
            product_quantity: count,
          });
        }
      }
      switch (this.stage) {
        case 0:
          this.stage = 1
          break
        case 1:
          if (this.deliveryType == 1) {
            oracle.axios("user/getProfile", {}, (res) => {
              this.userProfile = res.data;
            });
            this.stage = 2;
          } else {
            oracle.axios(
                "order/generateReceipt",
                {
                  coupon_id: this.selectedCoupon,
                  product_options: this.generateProductMap(),
                  payment_detail: this.payment_detail,
                  payment_order_type: 2,
                  shop_id: this.basketData.shop_id,
                },
                this.fetchFactor
            );
            this.stage = 3;
          }
          break
        case 2:
          oracle.axios(
              "order/generateReceipt",
              {
                coupon_id: this.selectedCoupon,
                payment_address: this.selectedAddress,
                payment_detail: this.payment_detail,
                payment_order_type: 1,
                shop_id: this.basketData.shop_id,
              },
              this.fetchFactor
          );
          break
        case 3:
          var data = {
            payment_from_credit: this.credit_switch,
            coupon_id: this.selectedCoupon,
            payment_detail: this.payment_detail,
            payment_order_type: this.deliveryType,
            shop_id: this.basketData.shop_id,
            product_options: this.generateProductMap(),
            payment_type: 1,
            payment_tag: "https://pwa.cluna.app/orders",
          };
          if (this.deliveryType == 1) data.payment_address = this.selectedAddress
          oracle.axios("payment/create", data, this.doPayment);
          break
      }
    },
    doPayment(response) {
      if (response.data == null || response.data.payment_url == null) {
        oracle.clearBasket();
        oracle.showMessage('خرید شما از اعتبار انجام شد، به بخش پیگیری سفارشات بروید'
            , 'پیگیری سفارش', () => {
              this.$router.push("orders")
            })
      } else {
        window.location = response.data.payment_url;
      }
    },
    fetchFactor(response) {
      this.factorReceipt = response.data;
      this.stage = 3;
    },
    plusItem(item) {
      if (item.product_count >= item.product_quantity) {
        return;
      }
      item.product_count++;
      oracle.addToBasket(item.product_id);
      this.checkOrder()
    },
    minusItem(item) {
      if (item.product_count == 0) {
        this.checkOrder()
        return;
      }
      item.product_count--;
      oracle.removeFromBasket(item.product_id);
      if (item.product_count == 0) {
        this.basketData.basket.splice(this.basketData.basket.indexOf(item), 1)
      }
      this.checkOrder()
    }, checkOrder() {
      let basket = oracle.getBasket()
      if (basket == null || basket.length == 0) {
        this.finalPrice = 0;
        return
      }
      oracle.axios(
          "order/checkOrder",
          {
            product_options: this.generateProductMap(),
            order_products: basket,
            shop_id: oracle.getShop(),
          },
          (response) => {
            let basket = response.data.basket
            for (let i = 0; i < basket.length; i++) {
              if (this.productMap[basket[i].product_id] == null) {
                this.productMap[basket[i].product_id] = []
              }
            }
            this.basketData = response.data;
            this.finalPrice = response.sum;
            this.getCoupons()
            this.getSuggests()
          }
      );
    }, checkBack() {
      if (this.stage == 0) {
        return
      }
      if (this.stage == 3) {
        if (this.deliveryType == 0) {
          this.stage = 1
          return;
        }
      }
      this.stage--
    }, getCoupons() {
      let basket = oracle.getBasket()
      if (basket == null || basket.length == 0) {
        return
      }
      oracle.axios("coupon/getList", {shop_id: oracle.getShop()}, (res) => {
        let array = []
        for (let j = 0; j < res.data.length; j++) {
          let flag = false
          for (let i = 0; i < basket.length; i++) {
            if (res.data[j].product != null && res.data[j].product.product_id != null
                && basket[i] == res.data[j].product.product_id) {
              flag = true
              break
            }
          }
          if (!flag) {
            array.push(res.data[j])
          }
        }
        this.coupons = array
      })
    }, getSuggests() {
      let basket = oracle.getBasket()
      if (basket == null || basket.length == 0) {
        return
      }
      oracle.axios("product/getSuggests", {shop_id: oracle.getShop(), basketDetail: basket}, (res) => {
        let array = []
        for (let j = 0; j < res.data.length; j++) {
          let flag = false
          for (let i = 0; i < basket.length; i++) {
            if (res.data[j].product_id != null
                && basket[i] == res.data[j].product_id) {
              flag = true
              break
            }
          }
          if (!flag) {
            array.push(res.data[j])
          }
        }
        this.suggests = array
      })
    }
  },
  mounted() {
    this.stage = 0
    oracle.axios('order/checkAvailability', {shop_id: oracle.getShop()}, (res) => {
      this.isAllowed = res.data.isAllowed
      this.purchaseAllowMessage = res.data.message
    })
  }, watch: {
    stage: function (value) {
      if (value == 0) {
        if (oracle.getShop() != null) {
          oracle.axios(
              "shop/getOne",
              {
                shop_id: oracle.getShop(),
              },
              (res) => {
                this.shop = res.data
                if (this.shop.shop_delivery) {
                  this.deliveryType = 1
                }
                this.checkOrder()
              }
          );
        }
      }
    }
  }
};
</script>
<style module>

.basket-css {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
}

.basket-css .footerBasket {
  z-index: 50;
  width: 100%;
  position: fixed;
  bottom: 0;
  box-shadow: 0 0 3px 1px #b4b4b4;
  background: #fff;
}

.basket-css .header-basket {
  z-index: 50;
  position: sticky;
  top: 0;
  background: #e1e3e5;
  padding: 15px 10px;
}

.basket-css .headerTop-basket {
  background: #4b4a4a;
  padding: 15px 10px;
  display: flex;
}

.basket-css .header-basket h2 {
  font-size: 12px;
  color: #000;
  font-weight: 100;
  text-align: justify;
}

.basket-css .amountBasket {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 15px;
}

.basket-css .btnaddAddress button {
  margin: 0 auto;
  display: flex;
  width: 100%;
}

.basket-css .imageBasket {
  width: 80px;
  height: 80px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  position: relative;
}

.basket-css .imageBasket-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.basket-css .imageBasket-top span {
  font-size: 10px;
}

.basket-css .imageBasket img {
  width: 70px;
  height: 70px;
  background-position: center center;
  object-fit: cover;
  border-radius: 50%;
}

.basket-css .img-basket img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.basket-css .textproductBasket span:nth-child(3),
.basket-css .amountBasket span:last-child {
  color: #7ec352 !important;
}

.basket-css .productBasket {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.basket-css .addproductBasket {
  width: auto;
}

.basket-css .addproductBasket ul {
  display: flex;
  padding-left: 0 !important;
}

.basket-css .addproductBasket ul li {
  padding: 0 5px;
}

.basket-css .contentBasket {
  padding: 15px 10px;
}

.basket-css .closetBasket .v-icon {
  color: #cccccc;
}

.basket-css .itemsBasket {
  width: 100%;
  flex: 1;
  overflow: auto;
}

.basket-css .btnaddAddress .v-icon {
  padding-left: 5px;
}

.basket-css .btnaddAddress a {
  text-decoration: none;
}

.basket-css .box-modal {
  padding: 10px 15px;
}

.basket-css .box-modal input::placeholder {
  font-size: 12px;
}

.basket-css .headline-tv {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.basket-css .headline-tv span {
  font-size: 12px !important;
  font-weight: bold;
}

.basket-css .backpages,
.basket-css .backpages .v-icon {
  color: #cad5d1;
  display: flex;
  align-items: center;
  font-weight: 100;
}

.basket-css .backpages .v-icon {
  font-size: 20px !important;
}

.basket-css .backpages span {
  font-weight: 100;
}

.basket-css .btnAddprice button {
  margin: 15px 0;
  background: #26c6da !important;
  color: #fff !important;
  width: 100%;
  height: 60px;
}

.basket-css .btnAddprice button {
  margin-bottom: 0;
}

.basket-css .btn-accept {
  width: 80%;
}

.basket-css .basketAllowBox {
  padding-top: 40%;
  align-items: center;
  justify-items: center;
  width: 100%;
  height: 100%;
  background: #7fc452;
}

.basket-css .basketAllowBox span {
  text-align: center;
  padding: 30px;
  font-weight: bold;
  color: white;
}

.basket-css .basketAllowBox button span {
  text-align: center;
  padding: 30px;
  font-weight: bold;
  color: #7fc452;
}

.basket-css .basketAllowBox img {
  width: 150px;
  height: 150px;
  max-width: 150px;
  max-height: 150px;
}

.basket-css .css-final {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #b8b7b7;
  display: flex;
  justify-content: space-between
}
</style>
